<div class="grid -mr-3 -ml-3 pn-container" >


    <p-toast key="messages" [life]="toastTimer" />
    <div class="col-12 lg:col-8 pn-order-1 ">
        <form #form="ngForm" >

            <div *ngIf="paymentInfo">
                <div class="grid formgrid p-fluid" >
                <div class="col-12 mb-3">
                </div>
                <div class="col-12 mb-3">
                    <div class="text-900 font-bold text-xl">Contact Information</div>
                </div>
                <div class="col-12 mb-2">
                    <p class="text-900 m-0 p-0 font-medium">{{customer.firstName}} {{customer.lastName}}</p>
                    <p class="text-600 m-0 p-0 text-sm">Email: {{customer.email}}</p>
                    <p class="text-600 m-0 p-0 text-sm">Phone: {{customer.phone}}</p>
                </div>
                <div class="col-12 field">
                    <label for="Country" class="text-900 font-medium mb-2">Country</label>
                    <p-dropdown [options]="countriesList" [(ngModel)]="address.countryCode" class="w-full mb-3"
                        placeholder="Select a country" optionLabel="label" optionValue="value"
                        (onChange)="onCountryChange($event)" name="customer.countryCode" [required]="true"
                        ariaLabel="Country Selection">
                    </p-dropdown>
                </div>
                <div class="col-12 lg:col-6 field mb-0">
                    <label for="address1" class="text-900 font-medium mb-2">Address</label>
                    <input id="address1" type="text" [(ngModel)]="address.street1" class="p-inputtext w-full mb-2" name="address1"
                        #address1="ngModel" required="true" aria-label="Address Line 1">
                    <span *ngIf="!address1.valid&&address1.touched" style="color:var(--text-error-color);">Required</span>
                </div>
                <div class="col-12 lg:col-6 field mb-0">
                    <label for="address2" class="text-900 font-medium mb-2">Address2</label>
                    <input id="address2" type="text" class="p-inputtext w-full mb-2" name="address2" [(ngModel)]="address.street2"
                        #address2="ngModel" aria-label="Address Line 2" />
                </div>
                <div class="col-12 lg:col-6 field mb-0">
                    <label for="city" class="text-900 font-medium mb-2">City</label>
                    <input id="city" type="text" class="p-inputtext w-full mb-2" name="city" [(ngModel)]="address.city"
                        #city="ngModel" required="true" aria-label="City" />
                    <span *ngIf="!city.valid&&city.touched" style="color:var(--text-error-color);">Required</span>
                </div>
                <div class="col-12 lg:col-6 field mb-2">
                    <label for="billingState" class="text-900 font-medium mb-2">State</label>
                    <span style="text-transform:uppercase">
                        <p-dropdown id="billingState" selectOnFocus="" [tabindex]="0" [options]="usaStatesList"
                            [(ngModel)]="address.state" *ngIf="address.countryCode=='US'" placeholder="Select a State"
                            optionLabel="label" optionValue="value" name="state" [required]="true" aria-label="State Selection">
                        </p-dropdown>
                        <input id="billingState" type="text" class="p-inputtext w-full" name="address.state"
                            [(ngModel)]="address.state" *ngIf="address.countryCode!='US'" aria-label="State">
                    </span>
                </div>
                <div class="col-12 lg:col-6 field mb-2">
                    <label for="zip" class="text-900 font-medium mb-2">Zip Code</label>
                    <input #zip="ngModel" type="text" class="p-inputtext w-full" name="zip" [(ngModel)]="address.postalCode"
                        required="true" pattern="^[0-9]{5}(?:[\-][0-9]{4})?$" aria-label="Zip Code" />
                    <span class="col-12 field mb-3" style="color: var(--text-error-color);" *ngIf="(zip.invalid && (zip.dirty || zip.touched))">
                        <div *ngIf="zip.errors?.['required']">Required</div>
                        <div *ngIf="zip.errors?.['pattern']">Please use the following formats: 12345 or 12345-1234</div>
                    </span>
                </div>
              </div>
            <div class="mt-3" *ngIf="total >= 3000">
                <div class="mb-3">
                    <div class="text-900 font-medium text-xl">Due to the size of this transaction, we are required to collect the following additional information</div>
                </div>
                <div class="mb-2">
                    <div class="flex flex-wrap gap-3 mb-2">
                        <div class="flex align-items-center">
                            <p-radioButton name="identity1Type" value="1"
                                #accountType="ngModel" [(ngModel)]="customerIdentity1.identityTypeId"
                                [required]="true" inputId="identity1Type1"
                                (onClick)="updateIdentity1Placeholder()"
                                [ariaLabel]="'Social Security Number'"></p-radioButton>
                            <label for="identity1Type1" class="ml-2">Social Security Number</label>
                        </div>
                        <div class="flex align-items-center">
                            <p-radioButton name="identity1Type" value="2"
                                #accountType="ngModel" [(ngModel)]="customerIdentity1.identityTypeId"
                                [required]="true" inputId="identity1Type2"
                                (onClick)="updateIdentity1Placeholder()"
                                [ariaLabel]="'Passport Number'"></p-radioButton>
                            <label for="identity1Type2" class="ml-2">Passport Number</label>
                        </div>
                        <div class="flex align-items-center">
                            <p-radioButton name="identity1Type" value="4"
                                #accountType="ngModel" [(ngModel)]="customerIdentity1.identityTypeId"
                                [required]="true" inputId="identity1Type3"
                                (onClick)="updateIdentity1Placeholder()"
                                [ariaLabel]="'Alien Registration Number'"></p-radioButton>
                            <label for="identity1Type3" class="ml-2">Alien Registration Number</label>
                        </div>
                    </div>
                     <div class="grid p-fluid gap-1">
                        <div class="lg:col-4 col-12 padding-0 flex flex-column" *ngIf="customerIdentity1.identityTypeId==2">
                            <p-dropdown id="countyCodeId1" [options]="countriesList"
                                [(ngModel)]="customerIdentity1.countryCode" placeholder="Select Country"
                                #countryCode1="ngModel" optionLabel="label" optionValue="value"
                                name="countryCode1" [required]="true"
                                [ariaLabel]="'Country Selection'">
                            </p-dropdown>
                        </div>
                        <div class="lg:col-4 col-12 padding-0" *ngIf="customerIdentity1.identityTypeId==1">
                            <input id="identity1" name="identity1" type="text" placeholder="{{identity1Placeholder}}" pattern="[0-9]{9}" maxlength="9"
                            style="width:100%" [(ngModel)]="customerIdentity1.value" required pInputText #identity1="ngModel"
                            aria-label="SSN" />
                            <span class="col-12 field mb-3" style="color: var(--text-error-color);" *ngIf="(identity1.invalid && (identity1.dirty || identity1.touched))">
                                <div *ngIf="identity1.errors">{{identity1Placeholder}} is invalid.</div>
                            </span>
                        </div>
                        <div class="lg:col-4 col-12 padding-0" *ngIf="customerIdentity1.identityTypeId!=1">
                            <input id="identity1" name="identity1" type="text" placeholder="{{identity1Placeholder}}" maxlength=""
                                style="width:100%" [(ngModel)]="customerIdentity1.value" required pInputText #identity1="ngModel"/>
                                <span class="col-12 field mb-3" style="color: var(--text-error-color);" *ngIf="(identity1.invalid && (identity1.dirty || identity1.touched))">
                                    <div *ngIf="identity1.errors?.['required']">{{identity1Placeholder}} is required.</div>
                                </span>
                        </div>
                    </div>
                    <p class="font-bold">And</p>
                    <div class="flex flex-wrap gap-3 mb-2">
                        <div class="flex align-items-center">
                            <p-radioButton name="identity2Type" value="3"
                                #accountType="ngModel" [(ngModel)]="customerIdentity2.identityTypeId"
                                [required]="true" inputId="identity2Type1"
                                (onClick)="updateIdentity2Placeholder()"
                                [ariaLabel]="'Drivers License'"></p-radioButton>
                            <label for="identity2Type1" class="ml-2">Drivers License</label>
                        </div>
                        <div class="flex align-items-center">
                            <p-radioButton name="identity2Type" value="0"
                                #accountType="ngModel" [(ngModel)]="customerIdentity2.identityTypeId"
                                [required]="true" inputId="identity2Type2"
                                (onClick)="updateIdentity2Placeholder()"
                                [ariaLabel]="'Other Photo Id Number'"></p-radioButton>
                            <label for="identity2Type2" class="ml-2">Other Photo Id Number</label>
                        </div>
                    </div>
                    <div class="grid p-fluid">
                        <div class="lg:col-4 col-12 flex flex-column" style="padding-bottom: 0;" *ngIf="customerIdentity2.identityTypeId==3">
                            <p-dropdown id="countyCodeId" [options]="countriesList"
                                [(ngModel)]="customerIdentity2.countryCode" placeholder="Select Country"
                                #countryCode="ngModel" optionLabel="label" optionValue="value"
                                name="countyCode" [required]="true" ariaLabel="Country Selection">
                            </p-dropdown>
                        </div>
                        <div class="lg:col-4 col-12 padding-0 flex flex-column" style="padding-bottom: 0;"  *ngIf="customerIdentity2.countryCode=='US'&&customerIdentity2.identityTypeId==3">
                            <p-dropdown id="stateCodeId" [options]="usaStatesList"
                                [(ngModel)]="customerIdentity2.region" placeholder="Select State"
                                #stateCode="ngModel" optionLabel="label" optionValue="value"
                                name="stateCode" [required]="true" ariaLabel="State Selection">
                            </p-dropdown>
                        </div>
                        <div  class="lg:col-4 col-12 padding-0 flex flex-column" style="padding-bottom: 0;"  *ngIf="customerIdentity2.countryCode=='CA'&&customerIdentity2.identityTypeId==3">
                            <p-dropdown id="provinceCodeId" [options]="canadaProvincesList"
                                [(ngModel)]="customerIdentity2.region" placeholder="Select Province"
                                #provinceCode="ngModel" optionLabel="name" optionValue="code"
                                name="provinceCode" [required]="true" ariaLabel="Province Selection">
                            </p-dropdown>
                        </div>
                        <div class="lg:col-4 col-12">
                            <input id="identity2" name="identity2" type="text" placeholder="{{identity2Placeholder}}"
                                style="width:100%" [(ngModel)]="customerIdentity2.value" required pInputText
                                #identity2="ngModel" required/>
                                <span class="col-12 field mb-3" style="color: var(--text-error-color);" *ngIf="(identity2.invalid && (identity2.dirty || identity2.touched))">
                                    <div *ngIf="identity2.errors">{{identity2Placeholder}} is required.</div>
                                </span>
                        </div>
                    </div>
                </div>
            </div>
            <p-divider />
          </div>

            <div class="grid formgrid p-fluid" [ngStyle]="{'display' : showFields ? 'flex' : 'none' }" >
                <div class="col-12 mb-3">
                <div class="text-900 font-bold text-xl">Payment</div>
                </div>
                <div class="col-12">
                    <div class="col-12 lg:col-6 field">
                        <div id="googlepay-container" [ngStyle]="{'display' : googlepayAvailable ? 'block' : 'none' ,'width':'100%'}">
                        </div>
                    </div>
                    <div class="col-12 lg:col-6 field ">
                        <div class=" w-full" id="applepay-container" [ngStyle]="{'display' : applepayAvailable ? 'block' : 'none' }">
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-1" [ngStyle]="{'display' : (googlepayAvailable || applepayAvailable || selectedPM.type == null) ? 'block' : 'none' ,'width':'100%'}">
                  <p-divider align="center">
                    <b>OR</b>
                    </p-divider>
                </div>
                <div class="col-12 field mb-1" >
                    <p-panel #creditcard header="Credit Card" [collapsed]="!(selectedPM.type=='creditcard')" [toggleable]="true"
                        [ngStyle]="{'display' : creditcardAvailable ? 'block' : 'none' }" (onBeforeToggle)="togglePanel($event,'creditcard')" iconPos="start"
                        expandIcon="pi pi-credit-card" collapseIcon=" pi pi-credit-card" toggler="header">
                            <div #adyendiv id="card" [ngStyle]="{'display' : !collapsedCreditCardPanel() ? 'block' : 'none' }"></div>
                    </p-panel>
                </div>
                <div class="col-12 field mb-1">
                    <p-panel #echeck header="Bank Account" [collapsed]="!(selectedPM.type=='echeck')" [toggleable]="true"
                        *ngIf="echeckAvailable" (onBeforeToggle)="togglePanel($event,'echeck')" iconPos="start"
                        expandIcon="pi pi-building-columns" collapseIcon="pi pi-building-columns" toggler="header">
                        <!-- <p-toast key="achPaymentMessages" [life]="toastTimer" /> -->
                        <div class="grid formgrid p-fluid  p-4" *ngIf="(selectedPM.type && selectedPM.type === 'echeck') && !collapsedEcheckPanel()">
                                <div class="col-12 lg:col-6 field mb-0"  *ngIf="!businessNameEntered">
                                    <label for="baFirstName" class="text-900 font-medium mb-3">First Name</label>
                                    <input id="baFirstName" [(ngModel)]="achPayment.firstName" type="text"
                                        class="p-inputtext w-full mb-3" name="baFirstName"
                                        (ngModelChange)="onChangeFirstNameLastNameEntered($event)" aria-label="First Name">
                                </div>
                                <div class="col-12 lg:col-6 field mb-0"  *ngIf="!businessNameEntered">
                                    <label for="baLastName" class="text-900 font-medium mb-3">Last Name</label>
                                    <input id="baLastName" [(ngModel)]="achPayment.lastName" type="text" class="p-inputtext w-full mb-3"
                                        name="baLastName" (ngModelChange)="onChangeFirstNameLastNameEntered($event)" aria-label="Last Name"
                                        aria-label="Last Name">
                                </div>
                            <div class="col-12 field mb-0 text-center" *ngIf="!businessNameEntered && !firstNameLastNameEntered"> OR </div>
                            <div class="col-12 field mb-0" *ngIf="!firstNameLastNameEntered">
                                <label for="businessName" class="text-900 font-medium mb-3">Business Name</label>
                                <input id="businessName" [(ngModel)]="achPayment.businessName" type="text" class="p-inputtext w-full mb-3"
                                    name="businessName" (ngModelChange)="onChangeBusinessNameEntered($event)" aria-label="Business Name">
                            </div>
                            <div class="col-12 lg:col-6 field mb-3">
                                <label for="routingNumber" class="text-900 font-medium mb-3">Routing Number</label>
                                <p-inputMask id="routingNumber" #routingNumber="ngModel"  name="routingNumber" class="w-full"
                                [(ngModel)]="achPayment.routingNumber" mask="999999999" [autoClear]="false" slotChar="" minlength="9"
                                ariaLabel="Routing Number" required></p-inputMask>
                                <div class="col-12 field mt-3 mb-0" style="color: var(--text-error-color);" *ngIf="(routingNumber.invalid && (routingNumber.dirty || routingNumber.touched)) && routingNumber.errors?.['required']" >
                                    Routing Number is required.
                                </div>
                                <div class="col-12 field mt-3 mb-0" style="color: var(--text-error-color);" *ngIf="(routingNumber.invalid && (routingNumber.dirty || routingNumber.touched)) && routingNumber.errors?.['minlength']" >
                                    Routing Number invalid.
                                </div>
                            </div>
                            <div class="col-12 lg:col-6 field mb-3">
                                <label for="verifyrourtingNumber" class="text-900 font-medium mb-3">Verify Routing Number</label>
                                <p-inputMask id="verifyrourtingNumber" #verifyrourtingNumber="ngModel"  name="verifyrourtingNumber" class="w-full"
                                [(ngModel)]="achPayment.verifyRoutingNumber" mask="999999999" [autoClear]="false" slotChar="" minlength="9" ariaLabel="Verify Routing Number" required></p-inputMask>
                                <div class="col-12 field mt-3 mb-0" style="color: var(--text-error-color);" *ngIf="verifyrourtingNumber.invalid && (verifyrourtingNumber.dirty || verifyrourtingNumber.touched) && verifyrourtingNumber.errors?.['required']">
                                    Verify Routing Number is required.
                                </div>
                                <div class="col-12 field mt-3 mb-0"
                                    *ngIf="routingNumber.touched && verifyrourtingNumber.touched && (routingNumber.value != verifyrourtingNumber.value) && !verifyrourtingNumber.errors?.['required']" style="color: var(--text-error-color);">
                                    <p>Routing Numbers do not match.</p>
                                </div>
                            </div>

                            <div class="col-12 lg:col-6 field mb-3">
                                <label for="accountNumber" class="text-900 font-medium mb-3">Account Number</label>
                                <input id="accountNumber" #accountNumber="ngModel" [(ngModel)]="achPayment.accountNumber" type="text"
                                    class="p-inputtext w-full mb-3" name="accountNumber" required (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                                    aria-label="Account Number">
                                <div class="col-12 field mt-3 mt-3" *ngIf="(accountNumber.invalid && (accountNumber.dirty || accountNumber.touched)) && accountNumber.errors?.['required']" style="color: var(--text-error-color);">
                                    Account Number is required.
                                </div>
                            </div>
                            <div class="col-12 lg:col-6 field mb-3">
                                <label for="verifyaccountNumber" class="text-900 font-medium mb-3">Verify Account Number</label>
                                <input id="verifyaccountNumber" #verifyaccountNumber="ngModel" type="text" class="p-inputtext w-full mb-3" (required)="selectedPM.type=='echeck'"
                                    name="verifyaccountNumber"  [(ngModel)]="achPayment.verifyAccountNumber" required (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                                    aria-label="Verify Account Number">
                                <div class="col-12 field mt-3" style="color: var(--text-error-color);" *ngIf="verifyaccountNumber.invalid && (verifyaccountNumber.dirty || verifyaccountNumber.touched) && verifyaccountNumber.errors?.['required']">
                                    Verify Account Number is required.
                                </div>
                                <div class="col-12 field mt-3"
                                    *ngIf="accountNumber.touched && verifyaccountNumber.touched && (accountNumber.value != verifyaccountNumber.value) && !verifyaccountNumber.errors?.['required']" style="color: var(--text-error-color);">
                                    <p>Account Numbers do not match.</p>
                                </div>
                            </div>
                        </div>
                    </p-panel>
                </div>
                <div class="col-12 field mb-1">
                    <p-panel header="PayPal" [collapsed]="!(selectedPM.type=='paypal')" [toggleable]="true"
                        *ngIf="paypalAvailable" (onBeforeToggle)="togglePanel($event,'paypal')" iconPos="start"
                        expandIcon="pi pi-paypal" collapseIcon="pi pi-paypal" toggler="header">
                        <p>Paypal</p>
                    </p-panel>
                </div>


                <div class="col-12 padding-0 mt-2 pt-2">
                    <p>Payments made online cannot be canceled or refunded and may take up to two (2) business days to process. By checking the box below you agree to be bound by all applicable terms and conditions.
                    This agreement may be modified at any time, with or without notice. You agree that by using this e-commerce product after any such modification, you will be deemed to have reviewed, agreed to,
                    and accepted any applicable modifications to our terms.</p>
                </div>
                <div class="col-12 padding-0 mt-2 pt-2">
                    <p-checkbox [binary]="true" [required]="true" inputId="termsAndConditions" name="termsAndConditions"
                        #termsAndConditions="ngModel" [(ngModel)]="termsAndConditionsChecked"
                        aria-label="Accept Terms And Conditions"></p-checkbox>
                    <label for="termsAndConditions">I have read and understand the above terms and conditions.</label>
                </div>
                <div class="grid col-12 field mb-0 mt-2 pt-2">
                    <div class="col-6">
                        <p-button label="Cancel Payment" (onClick)="cancelPayment()"
                            *ngIf="paymentInfo?.cancelURL">
                        </p-button>
                    </div>
                    <div class="col-6">
                        <p-button label="PayNow" (onClick)="submitPaymentForm()" [disabled]="(!paymentFieldsReady || form.invalid) || !termsAndConditionsChecked"></p-button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="col-12 lg:col-4 pn-order-2" *ngIf="paymentInfo">
        <div class="surface-card">
            <div class="flex justify-content-between ">
                <partner-image></partner-image>
                <div class="flex-auto m-3">
                    <span class="text-lg lg:text-lg font-bold mb-3">{{paymentInfo.partnerName}}</span>
                </div>
            </div>
            <div class="py-2 mt-3 border-bottom-1 surface-border">
                <div class="flex align-items-center mb-3">
                    <span class="text-900 font-medium">{{paymentInfo.skuLabel}} {{paymentInfo.skuValue}}</span>
                </div>
                <div class="flex justify-content-between align-items-center mb-3">
                    <span class="text-900">Subtotal</span>
                    <span class="text-900">{{paymentInfo.transactionAmount | currency:'USD':'symbol':'.2-2' }}</span>
                </div>
                <div class="flex justify-content-between align-items-center mb-3" *ngIf="selectedPM">
                    <span class="text-900">{{selectedPM.fee?.name}}</span>
                    <span class="text-900">{{selectedPM.fee?.amount| currency:'USD':'symbol':'.2-2'}}</span>
                </div>
                <div class="flex justify-content-between align-items-center mb-3" *ngIf="selectedPM">
                    <span class="text-900">Total</span>
                    <span class="text-900">{{selectedPM.totalAmount | currency:'USD':'symbol':'.2-2' }}</span>
                </div>
            </div>
            <div class="py-2 mt-3 border-bottom-1 surface-border">
                <div class="text-600 text-sm line-height-3 mb-2">{{paymentInfo.partnerDisclaimer}}</div>
            </div>
        </div>
    </div>
</div>
